/**
 * Motori i importit .docx (mammoth) — ngarkohet me kërkesë.
 *
 * Tri faqet e template-ave prisnin një `window.mammoth` që nuk e vinte askush:
 * pa <script> te index.html dhe pa varësi te package.json. Importi nga Word
 * dilte gjithmonë me «Mungon motori i importit — rifreskoni faqen», dhe
 * rifreskimi s'e ndryshonte asgjë sepse s'kishte çka të ngarkohej.
 *
 * Tani vjen nga npm, por në një chunk të vetin (~600KB): shkarkohet vetëm kur
 * dikush zgjedh vërtet një dokument, jo në ngarkimin e aplikacionit.
 */

let enginePromise = null;

export function loadDocxEngine() {
  if (!enginePromise) {
    enginePromise = import('mammoth/mammoth.browser')
      .then(m => m.default || m)
      // Një rrjet i rënë të mos e mbyllë importin përgjithmonë — provo prapë.
      .catch(err => { enginePromise = null; throw err; });
  }
  return enginePromise;
}

// I njëjti hartim stilesh për të tria faqet — Word-i i vjen me tituj e bold/italic.
export const DOCX_STYLE_MAP = [
  "p[style-name='Heading 1'] => h1:fresh",
  "p[style-name='Heading 2'] => h2:fresh",
  "p[style-name='Heading 3'] => h3:fresh",
  'b => strong',
  'i => em',
];

/**
 * .docx → HTML, me mesazhe që i thonë përdoruesit çfarë të bëjë.
 * Hedh `Error` me tekst për t'u shfaqur drejtpërdrejt.
 */
export async function docxToHtml(file) {
  const name = String(file?.name || '').toLowerCase();
  if (name.endsWith('.doc')) {
    throw new Error('Formati i vjetër .doc nuk lexohet në shfletues. Hapeni dokumentin në Word dhe ruajeni si .docx.');
  }
  if (!name.endsWith('.docx')) {
    throw new Error('Zgjidhni një dokument Word (.docx).');
  }
  let mammoth;
  try {
    mammoth = await loadDocxEngine();
  } catch (_) {
    throw new Error('Motori i importit nuk u ngarkua — kontrolloni lidhjen dhe provoni përsëri.');
  }
  const { value } = await mammoth.convertToHtml({ arrayBuffer: await file.arrayBuffer() }, { styleMap: DOCX_STYLE_MAP });
  if (!String(value || '').replace(/<[^>]+>/g, '').trim()) {
    throw new Error('Dokumenti duket bosh — s\'u gjet tekst për të importuar.');
  }
  return value;
}
